<template>
	<div>
		<vuetable ref="vuetable" :api-url="apiURL" :fields="fields" 
			pagination-path="" 
			:append-params="filters"
			:http-fetch="fetch"
			@vuetable:row-clicked="rowClick"
			@vuetable:checkbox-toggled="checkboxToggled"
		></vuetable>

		<div class="list__empty" v-if="empty">
			
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vuetable from 'vuetable-2/src/components/Vuetable';
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
	import debounce from 'debounce';

	import FilterableList from './List';

	import ColumnFileName from './ColumnFileName';
	import ColumnFileActions from './ColumnFileActions';

	import PaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin';

	Vue.component('column-filename', ColumnFileName);
	Vue.component('column-fileactions', ColumnFileActions);

	export default {
		name: 'ListFiles',
		components: {
			Vuetable,
			VuetablePagination
		},
		props: ['filters', 'apiURL'],
		watch: {
			filters: {
				deep: true,
				handler() {
					this.debounceReload();
				}
			}
		},
		data() {
			return {
				empty: false,
				fields: [
					{
			          	name: '__checkbox',
			          	titleClass: 'center aligned',
			          	dataClass: 'center aligned',
			          	width: '40px'
			        },
					{
						name: '__component:column-filename',
						sortField: 'name',
						title: 'Name',
					},
					{
						name: 'meta.filesize',
						title: 'Size',
						width: '100px'
					},
					{
						name: 'updated_at',
						sortField: 'updated_at',
						title: 'Modified',
						dataClass: '',
						width: '150px'
					},
					{
						name: '__component:column-fileactions',
						title: 'Actions',
						width: '80px'
					},
				],
			};
		},
		created(){
			//Set this during component creation to avoid multiple components sharing the same debounce
			this.debounceReload = debounce(function() {
				this.$refs.vuetable.reload();
			}, 250);
		},
		methods: {
			debounceReload() {},
			formatDate: value => value ? format(value, 'DD/MM/YY') : 'Never',
			onPaginationData(paginationData) {
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage(page) {
				this.$refs.vuetable.changePage(page)
			},
			onRowClass(dataItem, index) {
			},
			onLoading() {},
			onLoaded() {
				if(this.$refs.vuetable.displayEmptyDataRow) {
					this.empty = true;
				}
			},
			onLoadError() {},
			fetch(apiUrl, httpOptions) {
				this.error = false;
				this.loaded = false;
				this.loading = true;
				this.empty = false;

				return axios.get(apiUrl, httpOptions)
					.then((response) => {
						this.loaded = true;

						if(response.data && Array.isArray(response.data.data) && !response.data.data.length) {
							this.empty = true;
						}

						this.$emit('breadcrumbs-update', response.data.breadcrumbs);

						return response;
					})
					.catch(() => {
						this.error = true;
						this.$refs.vuetable.resetData();
					})
					.finally(() => {
						this.loading = false;
					});
			},
			load(force) {
				if(!force && (this.loaded || this.loading)) {
					return;
				}

				this.$refs.vuetable.reload();
			},
			rowClick(data){
			},
			checkboxToggled(isChecked, post){
				if(isChecked){
					this.$emit('selected-post', post);
				}else{
					this.$emit('deselected-post', post);
				}
			}
		}
	}
</script>
